export default __webpack_public_path__ + "media/src/assets/images/invoiceStatusMenu-14cf5197bc41a6303bc5d4308ee1221a.png";